import moment from 'moment'

export default {
	methods: 
    {	
		changeRazon()
		{
			this.ultimaRazon=this.dataForm[this.namePath].info_afiliacion.id_datos_razon
		},
		colMouseOver(Col=5,Col2=7)
		{
		  this.cardCol=Col;
		  this.cardCol2=Col2;
		  this.cardHover=4
		},  
		colMouseLeave(Col=8,Col2=4)
		{
		  this.cardCol=Col;
		  this.cardCol2=Col2;
		  this.cardHover=1
		},
		async updateDependiente()
		{
			this.active=0;
			const await1 = this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})
			const await2 = this.updateDataForm({state: 'info_afiliacion/id_list_tipo', data: 3})
			const await3 = this.updateDataForm({state: 'info_afiliacion/id_datos_razon', data: this.ultimaRazon})
			const await4 = this.updateDataForm({state: 'info_afiliacion/exonerado', data: 1})
			await await1
			await await2
			await await3
			await await4
		},
		async updateIndependiente()
		{
			this.active=1;
			const await1 =  this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})
			const await2 =  this.updateDataForm({state: 'info_afiliacion/id_list_tipo', data: 1})
			const await3 =  this.updateDataForm({state: 'info_afiliacion/id_datos_razon', data: 1})
			const await4 =  this.updateDataForm({state: 'info_afiliacion/exonerado', data: 0})
			await await1
			await await2
			await await3
			await await4
		},
		async buscarFtn(event)
		{
			await this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})

			//let buscarDatos_afiliado = await this.buscarIdb({tabla:'datos_afiliado',campo:'id',value: event})
			//let buscarInfo_afiliacion = await this.buscarIdb({tabla:'info_afiliacion',campo:'id_datos_afiliado',value: event})
			//let buscarServicios_inits = await this.buscarIdb({tabla:'servicios_inits',campo:'id_datos_afiliado',value: event})
			
			let getBackend = await this.getData({route: 'datos_afiliado_get', data: event})
			
			const await1 = this.updateDataForm({state: 'datos_afiliado', data: getBackend.datos_afiliado })
			const await2 = this.updateDataForm({state: 'servicios_inits', data: getBackend.servicios_inits })
			const await3 = this.updateDataForm({state: 'info_afiliacion/id_datos_asesor', data:  getBackend.info_afiliacion.id_datos_asesor
			})
			const await4 = this.updateDataForm({state: 'info_afiliacion/id_datos_razon', data:  getBackend.info_afiliacion.id_datos_razon
			})
			const await5 = this.updateDataForm({state: 'info_afiliacion/cargo', data:  getBackend.info_afiliacion.cargo
			})
			const await6 = this.updateDataForm({state: 'info_afiliacion/id_datos_contacto', data:  getBackend.info_afiliacion.id_datos_contacto
			})
			await await1
			await await2
			await await3
			await await4
			await await5
			await await6
		},
		async editarDataPostFtn()
		{
			await this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})
			this.editarDataPost=true
			for(var i=0;i<this.dataForm[this.namePath].servicios_nuevos.length; i++)
			{					
				let control = this.dataMultiple[this.namePath].multiple_servicios.findIndex( items => items.name===this.dataForm[this.namePath].servicios_nuevos[i].name) 
				if(control>=0)
				{
					this.$set(this.dataMultiple[this.namePath].multiple_servicios,control,this.dataForm[this.namePath].servicios_nuevos[i])
				}
			}	
			for(var i=0;i<this.dataForm[this.namePath].servicios_activos.length; i++)
			{					
				let control = this.dataMultiple[this.namePath].multiple_servicios.findIndex( items => items.name===this.dataForm[this.namePath].servicios_activos[i].name) 
				if(control>=0)
				{
					this.$set(this.dataMultiple[this.namePath].multiple_servicios,control,this.dataForm[this.namePath].servicios_activos[i])
				}
			}	
			return true
		},
		async limpiarForm()
		{			
			await this.resetDataIndex()
			await this.resetDataForm()
			await this.onInit()
			await this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})
			
		},
		changeIngreso()
		{
			let dias= moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('DD')
			if(dias>30)
			{
				dias=30
			}
			dias=31-dias
			this.updateDataForm({state: 'info_afiliacion/dias', data: dias})
			this.updateDataForm({state: 'info_afiliacion/mes_periodo', data: this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.mes})
			this.updateDataForm({state: 'info_afiliacion/ano_periodo', data: this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.ano})
		},
		async hideModal()
		{
			try{
				let await1 = this.resetGlobal({state: 'openModal'});
				let await2 = this.resetDataForm({state:'info_ingresos'})
				let await3 = true
				if(this.dataPost[this.namePath].data.length>0 && this.dataPost[this.namePath].data[0].datos_afiliado===undefined)
				{	
					await3= this.spliceDataPost(0)
				}
				const awaitAll = await Promise.all([await1, await2, await3])
				const throwAll = awaitAll.findIndex(list => list === false)
				if(throwAll!==-1)
				{
					throw ('in line 120 at 122')
				}
			}catch(e) {
				console.log('hide modal storemix afiliacion_nueva',e)
			}	
		},
		invalidNovedad(invalid)
		{	
			try {
				if(invalid)
				{
					this.errorsAportes='Los campos en rojo son obligatorios.'
					return true
				}

				let ninguno='Debe asignar la entidad de: '
				let total=0
				for(let i=0;i<this.dataMultiple[this.namePath].multiple_servicios.length;i++)
				{
					if(this.dataMultiple[this.namePath].multiple_servicios[i].check===1 && (this.dataMultiple[this.namePath].multiple_servicios[i].name==='Eps' || this.dataMultiple[this.namePath].multiple_servicios[i].name==='Afp' || this.dataMultiple[this.namePath].multiple_servicios[i].name==='Ccf') && this.predeterminados[this.namePath].multiple_servicios[i].id_list.toString()===this.dataMultiple[this.namePath].multiple_servicios[i].id_list.toString())
					{			
						ninguno=ninguno+' *'+this.dataMultiple[this.namePath].multiple_servicios[i].name+' '								
					}  
					if(this.dataMultiple[this.namePath].multiple_servicios[i].check===1)
					{
						total=total+1
					} 
				}
				if(ninguno!=='Debe asignar la entidad de: ')
				{
					this.errorsAportes=ninguno
					return true
				}
				if(total===1)
				{
					this.errorsAportes='Debe seleccionar almenos un servicio'
					return true
				}
						
				ninguno= ''
				for(let i=0;i<this.dataPost[this.namePath].data.length;i++)
				{
					if(this.dataPost[this.namePath].data[i].datos_afiliado.documento.toString()===this.dataForm[this.namePath].datos_afiliado.documento.toString() && (this.dataIndex[this.namePath]===false || this.dataIndex[this.namePath]===10000) )
					{			
						ninguno=ninguno+' El afiliado '+this.dataForm[this.namePath].datos_afiliado.name+' con documento '+this.dataForm[this.namePath].datos_afiliado.documento+' ya fue agrupado.'	
						i=10000							
					}   
				}
				if(ninguno!=='')
				{
					this.errorsAportes=ninguno
					return true
				}

					
				ninguno= ''
				for(let i=0;i<this.lists.datos_afiliado.length;i++)
				{
					if(this.lists.datos_afiliado[i].documento.toString()===this.dataForm[this.namePath].datos_afiliado.documento.toString() && this.lists.datos_afiliado[i].id_list_estado===1)
					{			
						ninguno=ninguno+' * El afiliado '+this.dataForm[this.namePath].datos_afiliado.name+' con documento '+this.dataForm[this.namePath].datos_afiliado.documento+' se encuentra activo en el sistema.'	
						i=10000							
					}   
				}
				if(ninguno!=='')
				{
					this.errorsAportes=ninguno
					return true
				}	

		
				let fechaHoy=this.fecha().fecha.minHoy
				let mesActual=parseInt(moment(fechaHoy).format('MM'))
				let anoActual=parseInt(moment(fechaHoy).format('YYYY'))


				let mesIngreso=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('MM'))
				let anoIngreso=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('YYYY'))
				

				if(mesActual!=mesIngreso || anoActual!=anoIngreso)
				{
					this.errorsAportes='El inicio de labores es direfente al mes actual'
					return false
				}
				
				this.errorsAportes=null
				return false
			}catch(e)
			{
				console.log(e)
			}
		}
	},
}